import React from "react";
import { useTranslation } from "react-i18next";
import JoinCreateOrganisation from "./JoinCreateOrganisation";
import clsx from "clsx";

const NoOrganisationView = (props: { className?: string }) => {
  const { t } = useTranslation();

  return (
    <div
      className={clsx(
        "flex flex-col flex-grow items-center justify-start p-4 text-gray-500 text-xs font-normal leading-4",
        props.className
      )}
    >
      <span className="mb-6 text-left">
        {t("organisationSettings.noOrganisationMessage")}
      </span>
      <JoinCreateOrganisation buttonStyle />
    </div>
  );
};

export default NoOrganisationView;
